import { Access, IAccess } from '../utils/access';
import { usePermissions } from 'react-admin';

export const useResourceAccess = (): IAccess => {
  const { permissions } = usePermissions();

  return permissions ?? Access(['unknown']);
};
